<template>
  <div>
    <CourseEventsList />
    <InfoModal />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import InfoModal from "./components/InfoModal.vue";
import CourseEventsList from "./components/CourseEventsList.vue";

export default {
  name: "App",
  components: {
    CourseEventsList,
    InfoModal
  },
  computed: {
    ...mapGetters(["withCourses"])
  },
  created() {
    this.fetchEvents();
    if (this.withCourses) {
      this.fetchCourses();
    }
  },
  methods: {
    fetchEvents() {
      this.$store.dispatch("loadEvents");
    },
    fetchCourses() {
      this.$store.dispatch("loadCourses");
    }
  }
};
</script>

<i18n>
{
  "cs": {
    "show_more_terms": "Zobrazit více termínů"
  },
  "en": {
    "show_more_terms": "Show more terms"
  }
}
</i18n>
